import { BLOCKS, Document } from '@contentful/rich-text-types'

export const internationalShippingModal: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value:
            'As a starting point, please login or create an account to send your cart to a customer service specialist.',
          data: {},
        },
      ],
      data: {},
    },
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value:
            'From there we will reach out with any additional questions and prepare to get a freight estimate for your shipment. This can take up to 2 days, depending on your delivery address.',
          data: {},
        },
      ],
      data: {},
    },
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value:
            'Ahead of processing your order, we will provide a formal quote including estimated lead time, freight and any applicable taxes for your review. Payment is due in full at the time the order is confirmed, ahead of production. We accept CC, Wire, ACH as payment methods.',
          data: {},
        },
      ],
      data: {},
    },
  ],
}
